package dev.terrakok.mapitan.domain

private const val PROJECT_HASH_PREFIX = "#project="
fun createProjectDeeplink(encodedProject: String): String {
    return getAppUri() + "$PROJECT_HASH_PREFIX$encodedProject"
}

fun extractEncodedProjectFromDeeplink(url: String?): String? {
    val hash = url?.substringAfter(PROJECT_HASH_PREFIX, "")
    return hash?.ifEmpty { null }
}

expect fun getAppUri(): String